module.exports = __webpack_public_path__ + "static/media/medaille1.78ed7f59.png";